import { kubernetesLiveUsageMgmtPostUsersMeOrganisationsCurrentKubernetesByTypeResources } from "../kubernetesLiveUsageMgmtPostUsersMeOrganisationsCurrentKubernetesByTypeResources";
import { RootState } from "@/store/store";
import { PostUsersMeOrganisationsCurrentKubernetesByTypeResourcesApiResponse } from "@/services/cloudchipr.api";

export const k8sLiveUsageResourceMetadataSelector = (
  state: RootState,
  fixedCacheKey: string,
):
  | Omit<
      PostUsersMeOrganisationsCurrentKubernetesByTypeResourcesApiResponse,
      "resources"
    >
  | undefined => {
  return kubernetesLiveUsageMgmtPostUsersMeOrganisationsCurrentKubernetesByTypeResources(
    fixedCacheKey,
  )(state)?.data;
};
